// extracted by mini-css-extract-plugin
export default {"spinner":"SmallSpinner_spinner__VIjSW","spin":"SmallSpinner_spin__NSMnz"};